import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { BigPicklistInput } from 'Packages/FacetDesign/Components';


const metaOverrideSet = buildFacetDesignOverride()
  .typeOverride('picklist', { _component: () => BigPicklistInput }, { ordinal: 200 });
export default metaOverrideSet;
